export default __webpack_public_path__ + "static/media/comment-alt-dots.f9966ea7.svg";